const CARD_HAND_UP_TIME = 15
const FIRST_GAME_STAGE_TIME = 15
const SECOND_GAME_STAGE_TIME = 15
const THIRD_GAME_STAGE_TIME = 15


export { CARD_HAND_UP_TIME, FIRST_GAME_STAGE_TIME, SECOND_GAME_STAGE_TIME, THIRD_GAME_STAGE_TIME }